import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        const parser = new DOMParser();
        this.element.querySelectorAll("action-text-attachment").forEach((attachment) => {
            if (attachment.getAttribute("content")) this._replaceWithTags(attachment, parser)
            else if (attachment.getAttribute("url") && 
                     attachment.getAttribute("content-type").includes("image/")) 
                        this._replaceWithImage(attachment)
        })
    }

    _replaceWithTags(attachment, parser) {
        attachment.replaceWith(parser.parseFromString(attachment.getAttribute("content"), "text/html").body.firstChild)
    }

    _replaceWithImage(attachment) {
        let img = document.createElement("img")
        img.src = attachment.getAttribute("url")
        img.alt = attachment.getAttribute("filename")
        img.setAttribute("loading", "lazy")
        img.classList.add("release-note-content-images")
        attachment.replaceWith(img)
    }
}
